import { isExactFeatureToggle } from "@/utils";

const FeatureToggleHoc = (WrappedComponent: any, featureToggle: string, inside: boolean = true) => {
  return (props) => {
    const featureToggleList = JSON.parse(localStorage.getItem("barte-features-list-user"));
    return isExactFeatureToggle(featureToggleList, featureToggle) && <WrappedComponent {...props}/>
  }
}

export { FeatureToggleHoc };